////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div class="c-form-quantity">
        <label class="u-screen-reader-text" for="productQuantity">{{ label }}</label>
        <input class="c-form-quantity_input" type="number" name="productQuantity" readonly="readonly" min="1" :value="quantityValue" tabindex="-1">
    </div>
`;


////////////////////
// Scripts
////////////////////
export default function VueQuantityInput() {

    Vue.component("quantity-input", {

        template,

        props: {
            label: {
                type: String,
                default: 'Quantity'
            },
            defaultValue: {
                type: Number,
                default: 1
            },
            max: {
                type: Number,
                required: false
            },
            forceDefaultValue: {
                type: Boolean,
                required: false
            }
        },

        data() {
            return {
                quantityValue: '',
                isQuantityMin: true,
                isQuantityMax: false
            };
        },

        watch: {
            defaultValue: function(newValue) {
                if (this.forceDefaultValue) {
                    this.quantityValue = newValue
                    this.updateQuantityStatus()
                }
            }
        },

        mounted() {
            this.quantityValue = this.defaultValue
            this.updateQuantityStatus()
        },

        methods: {
            /////////////////
            // Callbacks
            /////////////////
            onIncrease() {
                // Product form
                if (!this.forceDefaultValue) {
                    if (this.quantityValue < this.max) {
                        this.quantityValue++
                        this.onUpdateQuantity()
                    }
                    this.updateQuantityStatus()
                }

                this.$emit('onIncrease', this.quantityValue)
            },

            onDecrease() {
                // If next quantity is 0, delete item
                if (this.quantityValue === 1) {
                    return this.$emit('onDelete')
                }

                // Product form
                if (!this.forceDefaultValue) {
                    if (this.quantityValue > 1 ) {
                        this.quantityValue--
                        this.onUpdateQuantity()
                    }
                    this.updateQuantityStatus()
                }

                this.$emit('onDecrease', this.quantityValue)
            },

            onUpdateQuantity() {
                this.$emit('onUpdate', this.quantityValue)
            },

            /////////////////
            // Methods
            /////////////////
            updateQuantityStatus() {
                let quantityMin = 1

                // Cart
                if (this.forceDefaultValue) {
                    quantityMin = 0
                }

                if (this.quantityValue >= this.max) {
                    this.isQuantityMax = true
                } else {
                    this.isQuantityMax = false
                }

                if (this.quantityValue > quantityMin) {
                    this.isQuantityMin = false
                } else {
                    this.isQuantityMin = true
                }
            }
        }
    });
}
